import { render, staticRenderFns } from "./DermDetail.vue?vue&type=template&id=5f51cdec&scoped=true&"
import script from "./DermDetail.vue?vue&type=script&lang=js&"
export * from "./DermDetail.vue?vue&type=script&lang=js&"
import style0 from "./DermDetail.vue?vue&type=style&index=0&id=5f51cdec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51cdec",
  null
  
)

export default component.exports